let locale = {
    zh:{
        app:{
            feedbackTypeList:[
                {name:'询价',value:"询价"},
                {name:'咨询',value:"咨询"},
                {name:'投诉',value:"投诉"},
                {name:'建议',value:"建议"},
                {name:'其他',value:"其他"}
            ],
            message:{
                uploadErrpr:"上传失败，请上传bmp, gif, jpg, jpeg, png, doc, docx, xls, xlsx, ppt, pptx, html, htm, txt, rar, zip, gz, bz2, mp4, avi, rmvb, pdf格式文件",
                downloadTips:"该产品暂未提供下载资料",
            },
            emails:"电子邮件",
            contactNumber:"联系电话",
            onlineinquiry:"在线询价",
            backTop:"返回顶部",
            menuTitle:"菜单列表",
            feedback:{
                title:"客户留言",
                feedType:"留言类型",
                name:"名称",
                email:"邮箱",
                phone:"联系电话",
                company:"公司名称",
                content:"留言内容",
                fileName:"上传BOM",
                submit:"提交留言信息",
                feedType_tips:"请选择留言类型",
                name_tips:"请输入您的名称",
                email_tips:"请输入您的邮箱",
                phone_tips:"请输入您的联系电话",
                company_tips:"请输入您的公司名称",
                content_tips:"请输入您的留言内容",
                namerequireTips:"姓名不能为空",
                phonerequireTips:"联系电话不能为空",
                addresult:"提交成功"
            }
        },
        home:{
            menu:{
                menu1:"首页",
                menu2:"我的产品",
                menu3:"技术中心",
                menu4:"方案定制",
                menu5:"公司动态",
                menu6:"关于我们",
                menu7:"联系我们",
                menu8:"淘宝商城",
            },
            module:{
                name1:"主营产品",
                name2:"关于酷赛威",
                learmode:"了解更多",
                name3:"技术中心",
                name4:"推荐产品",
                name5:"合作伙伴"
            },
            footer:{
                module1:"关于我们",
                module2:"公司简介",
                module3:"产品中心",
                module4:"方案定制",
                module5:"联系我们",
                address:"地址：",
                contentInfo:"电话：",
                email:"邮箱："
            }
        },
        companynews:{
            pagebackbtnName:"返回上一页",
            releaseTime:"发布时间",
            preInfoTips:"上一篇",
            nextInfoTips:"下一篇",
            latestInformation:"最新信息",
            emptyTips:"没有发布信息",
        },
        product:{
            questionBtn:"立即留言",
            downloadBtn:"下载文件",
            tableName:"参数项",
            tableContent:"参数值",
            tableUnit:"单位",
            productDes:"产品详情信息"
        }
    },
    en:{
        app:{
            feedbackTypeList:[
                {name:'Inquiry',value:"询价"},
                {name:'Consultation',value:"咨询"},
                {name:'Complaint',value:"投诉"},
                {name:'Suggestion',value:"建议"},
                {name:'Other',value:"其他"}
            ],
            message:{
                uploadErrpr:"Upload failed. Please upload files in the following formats: bmp, gif, jpg, jpeg, png, doc, docx, xls, xlsx, ppt, pptx, html, htm, txt, rar, zip, gz, bz2, mp4, avi, rmvb, pdf",
                downloadTips:"The product does not provide downloadable materials at this time",
            },
            emails:"Emails",
            contactNumber:"Contact Number",
            onlineinquiry:"Online Inquiry",
            backTop:"Return to top",
            menuTitle:"menu list",
            feedback:{
                title:"Customer Message",
                feedType:"Message Type",
                name:"name",
                email:"email",
                phone:"Contact number",
                company:"Company Name",
                content:"Message content",
                fileName:"upload BOM",
                submit:"Submit message information",
                feedType_tips:"Please select the message type",
                name_tips:"Please enter your name",
                email_tips:"Please enter your email",
                phone_tips:"Please enter your contact phone number",
                company_tips:"Please enter your company name",
                content_tips:"Please input your message content",
                addresult:"submit success"

            }
        },
        home:{
            menu:{
                menu1:"Home",
                menu2:"Product",
                menu3:"Technology Center",
                menu4:"Customized Solution",
                menu5:"Company News",
                menu6:"About Me",
                menu7:"Contact Us",
                menu8:"Taobao Mall",
            },
            module:{
                name1:"Main products",
                name2:"About Kousaiwei",
                learmode:"Learn more",
                name3:"Technology Center",
                name4:"Recommended Products",
                name5:"My Client"
            },
            footer:{
                module1:"About Us",
                module2:"Company Profile",
                module3:"Product Center",
                module4:"Customized Solution",
                module5:"Contact Us",
                address:"address：",
                contentInfo:"telephone：",
                email:"email："
            }
        },
        companynews:{
            pagebackbtnName:"Back to previous page",
            releaseTime:"release time",
            preInfoTips:"the previous",
            nextInfoTips:"the next",
            latestInformation:"Latest information",
            emptyTips:"No information has been released",
        },
        product:{
            questionBtn:"Leave a message",
            downloadBtn:"Download file",
            tableName:"parameter item",
            tableContent:"parameter value",
            tableUnit:"unit",
            productDes:"Product details"
        }

    },
    fr:{
        app:{
            feedbackTypeList:[
                {name:'Devis',value:"询价"},
                {name:'Consultation',value:"咨询"},
                {name:'Plainte',value:"投诉"},
                {name:'Suggestion',value:"建议"},
                {name:'Autre',value:"其他"}
            ],
            message:{
                uploadErrpr:"Téléchargement échoué, veuillez télécharger des fichiers au format bmp, gif, jpg, jpeg, png, doc, docx, xls, xlsx, ppt, pptx, html, htm, txt, rar, zip, gz, bz2, mp4, avi, rmvb, pdf.",
                downloadTips:"Ce produit ne fournit pas encore de documents à télécharger.",
            },
            emails:"électronique",
            contactNumber:"téléphone",
            onlineinquiry:"Demande de devis",
            backTop:"Retour en haut",
            menuTitle:"Liste des menus",
            feedback:{
                title:"Message du client",
                feedType:"Type de message",
                name:"Nom",
                email:"Boîte aux lettres",
                fileName:"Télécharger la BOM",
                phone:"Numéro de téléphone",
                company:"Nom de l'entreprise",
                content:"Contenu du message",
                submit:"Soumettre les informations du message",
                feedType_tips:"Veuillez sélectionner le type de message",
                name_tips:"Veuillez saisir votre nom",
                email_tips:"Veuillez saisir votre adresse e-mail",
                phone_tips:"Veuillez saisir votre numéro de téléphone portable",
                company_tips:"Veuillez saisir le nom de votre entreprise",
                content_tips:"Veuillez saisir le contenu de votre message",
                addresult:"Envoi réussi"
            }
        },
        home:{
            menu:{
                menu1:"Page d'accueil",
                menu2:"Mon produit",
                menu3:"Centre technique",
                menu4:"solution personnalisée",
                menu5:"Actualités de l'entreprise",
                menu6:"À propos de moi",
                menu7:"Contactez-nous",
                menu8:"Le centre commercial Taobao",
            },
            module:{
                name1:"Produits principaux",
                name2:"À propos de Kusawei",
                learmode:"En savoir plus",
                name3:"Centre technique",
                name4:"Produits recommandés",
                name5:"Mon Client"
            },
            footer:{
                module1:"À propos de nous",
                module2:"Présentation de l'entreprise",
                module3:"Centre de produits",
                module4:"solution personnalisée",
                module5:"Contactez-nous",
                address:"adresse：",
                contentInfo:"téléphone：",
                email:"boîte aux lettres："
            }
        },
        companynews:{
            pagebackbtnName:"Retour à la page précédente",
            releaseTime:"Date de publication",
            preInfoTips:"précédent",
            nextInfoTips:"Prochain article",
            latestInformation:"Dernières informations",
            emptyTips:"Pas d'information publiée",
        },
        product:{
            questionBtn:"Message",
            downloadBtn:"Télécharger le fichier",
            tableName:"paramètre",
            tableContent:"valeur du paramètre",
            tableUnit:"Unité",
            productDes:"Informations détaillées sur le produit"
        }

    }
}

export  default  locale;